// extracted by mini-css-extract-plugin
export default {"customer-service-contact":"src-assets-style-scss-___CustomerServiceContact__customer-service-contact___melhI"};